import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_20bj5qkmcj: FaireBrandEntity = {
  token: "b_20bj5qkmcj",
  type: "brand",
  name: "Tribe + Temple",
  avatarUrl:
    "https://cdn.faire.com/fastly/5e4e5c0b67377e16f1a424a0e80b97c6780f9a515db5b51a6f279c7d7a7bf918.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/73c02582a6710e6ec4a38a9db37930315f573995a4981d4f92b37819107c0d71.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5e4e5c0b67377e16f1a424a0e80b97c6780f9a515db5b51a6f279c7d7a7bf918.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/73c02582a6710e6ec4a38a9db37930315f573995a4981d4f92b37819107c0d71.jpeg",
  location: "Savannah, GA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 55,
  isTopShop: true,
  isInsider: true,
  description:
    "Tribe and Temple is a colorful jewelry and accessory brand based in Savannah, Georgia. The brand is continuously inspired by the American regions in which designer Emmy Davidian has lived. From the southwest, to the northeast and now the low country.\n\nTribe and Temple takes pride in being more than just a brand, it is also a safe place for everyone. Tribe and Temple's handcrafted accessories are designed to reflect the culture and character of resilient women. We believe in equality and women's empowerment. By spreading our powerful messages through our colorful and uplifting products, we hope to inspire change and create social awareness. It is important that we unite: it is only then we can make a difference.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:30.513Z",
    importedBy: "entity-db-cli",
  },
};
